import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import isObject from 'lodash-es/isObject';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { usePanneauResource } from '@panneau/core/contexts';
import { useQuery } from '@panneau/core/hooks';
import { useResourceValues } from '@panneau/intl';
import ResourceItemsList from '@panneau/list-resource-items';
import Dialog from '@panneau/modal-dialog';

var _excluded = ["id", "resource", "title", "query", "paginated", "size", "onClose", "listProps", "className", "children"];
var propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  resource: PropTypes.string,
  title: PropTypes.string,
  query: PropTypes.shape(),
  paginated: PropTypes.bool,
  size: PropTypes.string,
  onQueryChange: PropTypes.func,
  onQueryReset: PropTypes.func,
  onPageChange: PropTypes.func,
  onClose: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  listProps: PropTypes.object,
  className: PropTypes.string,
  children: PropTypes.node
};
var defaultProps = {
  resource: null,
  title: null,
  query: null,
  paginated: true,
  size: 'xl',
  onQueryChange: PropTypes.func,
  onQueryReset: PropTypes.func,
  onPageChange: PropTypes.func,
  onClose: null,
  listProps: null,
  className: null,
  children: null
};
var ModalResourceItems = function ModalResourceItems(_ref) {
  var id = _ref.id,
    providedResource = _ref.resource,
    title = _ref.title,
    initialQuery = _ref.query,
    paginated = _ref.paginated,
    size = _ref.size,
    onClose = _ref.onClose,
    listProps = _ref.listProps,
    className = _ref.className,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var panneauResource = usePanneauResource(providedResource);
  var resource = isObject(providedResource) ? providedResource : panneauResource;
  var resourceValues = useResourceValues(resource);
  var finalQuery = useMemo(function () {
    return _objectSpread({}, initialQuery);
  }, [initialQuery]);
  var _useQuery = useQuery(finalQuery, paginated),
    query = _useQuery.query,
    onPageChange = _useQuery.onPageChange,
    onQueryChange = _useQuery.onQueryChange,
    onQueryReset = _useQuery.onQueryReset;

  // TODO: add default list props and stuff?

  return /*#__PURE__*/React.createElement(Dialog, {
    id: id,
    title: title || /*#__PURE__*/React.createElement(FormattedMessage, {
      values: resourceValues,
      id: "XLVfN6",
      defaultMessage: [{
        "type": 0,
        "value": "Find "
      }, {
        "type": 1,
        "value": "a_singular"
      }]
    }),
    size: size,
    onClose: onClose,
    className: className
  }, /*#__PURE__*/React.createElement(ResourceItemsList, Object.assign({
    resource: resource,
    query: query,
    onPageChange: onPageChange,
    onQueryChange: onQueryChange,
    onQueryReset: onQueryReset,
    listProps: listProps
  }, props)), children);
};
ModalResourceItems.propTypes = propTypes;
ModalResourceItems.defaultProps = defaultProps;

export { ModalResourceItems as default };
